const media = document.querySelector('.js-media');
const mediaVideo = document.querySelector('.js-media-video');

if(mediaVideo) {
  mediaVideo.addEventListener('play', function() {
      media.classList.add('playing');
  });
  
  mediaVideo.addEventListener('pause', function() {
      media.classList.remove('playing');
  });
}